import { useMemo, useState } from "react";
import NavBar from "../../component/navBar/NavBar";
import Title from "../../component/title/Title";
import SearchInput from "../../component/searchInput/SearchInput";
import LoadingSpinner from "../../component/loading/LoadingSpinner";
import { SecondaryButton } from "../../component/buttonComponent/ButtonComponent";
import { useAuth } from "../../config/utilities/useAuth";
import { useInstitutionDeeplinks } from "../../config/utilities/useInstitutionDeeplinks";
import { openDeeplink } from "../../config/utilities/deeplinkHelpers";
import "../../pages/masterAdmin/pages/MasterAdminInstitutions.css";
import "./ExternalApps.css";

const getDeeplinkId = (deeplink) =>
  deeplink?.deeplinkId || deeplink?._id || deeplink?.url || "";

export default function ExternalApps() {
  const { privilege } = useAuth();
  const { deeplinks = [], loading } = useInstitutionDeeplinks(privilege?.institutionId);
  const [search, setSearch] = useState("");

  const filteredDeeplinks = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return deeplinks;

    return deeplinks.filter((deeplink) => {
      const label = deeplink.label?.toLowerCase() || "";
      const url = deeplink.url?.toLowerCase() || "";
      return label.includes(query) || url.includes(query);
    });
  }, [deeplinks, search]);

  return (
    <div className="main-page external-apps-page">
      <NavBar type="externalApps" />
      <div className="content-area">
        <div className="title-container mobile-hide-page-title">
          <Title
            title="External Apps"
            subtitle="Quick access to external tools linked to your institution"
            titleSize="1.5rem"
            subtitleSize="1rem"
            gap="0.5rem"
            lineHeight="2rem"
          />
        </div>
        <div className="main-content-container">
          <div className="external-apps">
            <div className="external-apps-toolbar">
              <div className="external-apps-toolbar-left">
                <SearchInput
                  containerWidth="22rem"
                  containerHeight="2.5rem"
                  text="Search by label or URL..."
                  value={search}
                  onChangeText={(e) => setSearch(e.target.value)}
                />
                <span className="external-apps-count">
                  {filteredDeeplinks.length} app
                  {filteredDeeplinks.length === 1 ? "" : "s"}
                </span>
              </div>
            </div>

            {loading && deeplinks.length === 0 ? (
              <div className="external-apps-loading">
                <LoadingSpinner size="large" color="#ffb502" />
              </div>
            ) : filteredDeeplinks.length === 0 ? (
              <div className="external-apps-empty">
                <h3>No external apps found</h3>
                <p>
                  {search
                    ? "Try a different search term or clear the filter."
                    : "No external apps are linked to your institution yet."}
                </p>
              </div>
            ) : (
              <div className="ma-institutions-grid">
                {filteredDeeplinks.map((deeplink) => (
                  <article
                    key={getDeeplinkId(deeplink)}
                    className="ma-institution-card external-apps-card"
                  >
                    <div className="ma-institution-card-header">
                      <div className="ma-institution-card-title-wrap">
                        <h3 className="ma-institution-card-title">
                          {deeplink.label}
                        </h3>
                      </div>
                      <SecondaryButton
                        width="4.25rem"
                        label="Open"
                        onClickFunction={() => openDeeplink(deeplink.url)}
                      />
                    </div>

                    <div className="ma-institution-card-meta">
                      <span className="ma-institution-meta-label">URL</span>
                      <span className="ma-institution-meta-value">
                        {deeplink.url}
                      </span>
                    </div>
                  </article>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
